/* istanbul ignore file */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import history from "../../utilities/history";
import { CommonRoutes } from "@kf/ic2fx";

export interface NavigationState {
  context: string;
}

const initialState: NavigationState = {
  context: "assessmentAnalytics"
};

export const gotoLogin = createAsyncThunk("nav/gotoLogin", () => {
  history.push(CommonRoutes.Login);
});

export const gotoHome = createAsyncThunk("nav/gotoHome", () => {
  history.push(CommonRoutes.Home);
});

export const gotoForbiddenPage = createAsyncThunk("nav/gotoErrorPage", () => {
  history.push(CommonRoutes.Forbidden);
});

export const gotoSignInErrorPage = createAsyncThunk("nav/gotoErrorPage", () => {
  history.push(CommonRoutes.SignInError);
});

export const gotoErrorPage = createAsyncThunk("nav/gotoErrorPage", () => {
  history.push(CommonRoutes.InternalServerError);
});

export const gotoIdleTimeoutError = createAsyncThunk(
  "/gotoIdleTimeoutErrorPage",
  () => {
    history.push("/idletimeouterror");
  }
);

export const gotoInvalidUser = createAsyncThunk("nav/gotoInvalidUser", () => {
  history.push("/invalidUser");
});

export const goBack = createAsyncThunk("nav/gotoInvalidUser", () => {
  history.back(); //goBack
});

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavContext: (state, action) => {
      state.context = action.payload;
    }
  }
});

export const { setNavContext } = navigationSlice.actions;

export default navigationSlice.reducer;
